import { TableCell, TableRow } from '@folio/components';
import { ErrorMessage } from './ErrorMessage';

// https://stackoverflow.com/questions/398734/colspan-all-columns
const RANDOM_BIG_NUMBER_THAT_SHOULD_BE_BIGGER_THAN_TABLE_COLUMNS = 42;

export function ErrorRow({ children }: { children?: React.ReactNode }) {
  return (
    <TableRow>
      <TableCell colSpan={RANDOM_BIG_NUMBER_THAT_SHOULD_BE_BIGGER_THAN_TABLE_COLUMNS}>
        <ErrorMessage>{children}</ErrorMessage>
      </TableCell>
    </TableRow>
  );
}
